import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';

function RequestEstimate() {
  const [selectedDate, setSelectedDate] = useState(null);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phoneNumber: '',
    email: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    date: null,
    products: {
      Carpet: false,
      HardWood: false,
      Glasstile: false,
      LuxuryVinyl: false,
      Tile: false,
      Vinyl: false,
      Metaltile: false,
      NaturalStones: false,
    },
    comment: '',
    keepMeUpdated: false,
  });

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setFormData((prevFormData) => ({
      ...prevFormData,
      date: date,
    }));
  };

  const handleCheckboxChange = (checkboxName) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      products: {
        ...prevFormData.products,
        [checkboxName]: !prevFormData.products[checkboxName],
      },
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const formresponse = await axios.post(`${process.env.REACT_APP_API_URL}/api/form`, formData);
      alert(formresponse.data.data1);
      window.location.reload();
      window.scrollTo(0, 0);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const inputClass =
    'form-control border-gray-200 rounded-lg py-2.5 px-3 text-sm focus:border-[#803333] focus:shadow-none';

  return (
    <section className="py-10 md:py-14">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
            Request an estimate
          </h2>
          <p className="text-sm uppercase tracking-wide text-gray-500 m-0">
            Meet with one of our skilled project specialists to get started
          </p>
        </div>

        <form
          className="max-w-3xl mx-auto bg-white rounded-xl shadow-sm border border-gray-100 p-5 md:p-8"
          onSubmit={handleSubmit}
        >
          <div className="row g-3">
            <div className="col-md-6">
              <label htmlFor="firstname" className="form-label text-xs font-semibold uppercase tracking-wide text-gray-500">
                First Name
              </label>
              <input
                type="text"
                className={inputClass}
                id="firstname"
                placeholder="First Name"
                value={formData.firstName}
                onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
                required
              />
            </div>
            <div className="col-md-6">
              <label htmlFor="lastname" className="form-label text-xs font-semibold uppercase tracking-wide text-gray-500">
                Last Name
              </label>
              <input
                type="text"
                className={inputClass}
                id="lastname"
                placeholder="Last Name"
                value={formData.lastName}
                onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
                required
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="phoneNumber" className="form-label text-xs font-semibold uppercase tracking-wide text-gray-500">
                Phone
              </label>
              <input
                type="text"
                className={inputClass}
                id="phoneNumber"
                placeholder="Phone"
                value={formData.phoneNumber}
                onChange={(e) => setFormData({ ...formData, phoneNumber: e.target.value })}
                required
              />
            </div>
            <div className="col-md-6">
              <label htmlFor="email" className="form-label text-xs font-semibold uppercase tracking-wide text-gray-500">
                Email
              </label>
              <input
                type="email"
                className={inputClass}
                id="email"
                placeholder="Email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
              />
            </div>

            <div className="col-12">
              <label htmlFor="address" className="form-label text-xs font-semibold uppercase tracking-wide text-gray-500">
                Address
              </label>
              <input
                type="text"
                className={inputClass}
                id="address"
                placeholder="1234 Main St"
                value={formData.address}
                onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                required
              />
            </div>

            <div className="col-md-5">
              <label htmlFor="city" className="form-label text-xs font-semibold uppercase tracking-wide text-gray-500">
                City
              </label>
              <input
                type="text"
                className={inputClass}
                id="city"
                placeholder="City"
                value={formData.city}
                onChange={(e) => setFormData({ ...formData, city: e.target.value })}
                required
              />
            </div>
            <div className="col-md-4">
              <label htmlFor="state" className="form-label text-xs font-semibold uppercase tracking-wide text-gray-500">
                State
              </label>
              <input
                type="text"
                className={inputClass}
                id="state"
                placeholder="State"
                value={formData.state}
                onChange={(e) => setFormData({ ...formData, state: e.target.value })}
                required
              />
            </div>
            <div className="col-md-3">
              <label htmlFor="zip" className="form-label text-xs font-semibold uppercase tracking-wide text-gray-500">
                Zip
              </label>
              <input
                type="text"
                className={inputClass}
                id="zip"
                placeholder="Zip"
                value={formData.zip}
                onChange={(e) => setFormData({ ...formData, zip: e.target.value })}
                required
              />
            </div>

            <div className="col-12">
              <label className="form-label text-xs font-semibold uppercase tracking-wide text-gray-500">
                Preferred date
              </label>
              <DatePicker
                selected={selectedDate}
                onChange={handleDateChange}
                placeholderText="Select a date"
                className={inputClass}
                dateFormat="MM/dd/yyyy"
                isClearable
              />
            </div>

            <div className="col-12">
              <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-3">
                What products are you interested in?
              </p>
              <div className="row g-2">
                {Object.keys(formData.products).map((productName) => (
                  <div key={productName} className="col-6 col-md-4">
                    <label
                      htmlFor={productName}
                      className={`flex items-center gap-2 rounded-lg border px-3 py-2 text-sm cursor-pointer transition-colors ${
                        formData.products[productName]
                          ? 'border-[#803333] bg-[#803333]/5 text-[#803333]'
                          : 'border-gray-200 text-gray-700 hover:border-gray-300'
                      }`}
                    >
                      <input
                        className="form-check-input m-0"
                        type="checkbox"
                        id={productName}
                        checked={formData.products[productName]}
                        onChange={() => handleCheckboxChange(productName)}
                      />
                      {productName}
                    </label>
                  </div>
                ))}
              </div>
            </div>

            <div className="col-12">
              <label htmlFor="comment" className="form-label text-xs font-semibold uppercase tracking-wide text-gray-500">
                Comment
              </label>
              <input
                type="text"
                className={inputClass}
                id="comment"
                placeholder="Tell us about your project"
                value={formData.comment}
                onChange={(e) => setFormData({ ...formData, comment: e.target.value })}
                required
              />
            </div>

            <div className="col-12">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="keepMeUpdated"
                  checked={formData.keepMeUpdated}
                  onChange={() =>
                    setFormData((prevFormData) => ({
                      ...prevFormData,
                      keepMeUpdated: !prevFormData.keepMeUpdated,
                    }))
                  }
                />
                <label className="form-check-label text-sm text-gray-600" htmlFor="keepMeUpdated">
                  Keep me up to date with exclusive offers.
                </label>
              </div>
            </div>

            <div className="col-12 pt-2">
              <button
                type="submit"
                className="w-100 text-white font-semibold py-3 rounded-lg border-0 hover:opacity-90 transition-opacity"
                style={{ backgroundColor: '#803333' }}
              >
                Send request
              </button>
            </div>
          </div>
        </form>
      </div>
    </section>
  );
}

export default RequestEstimate;
